document.addEventListener('DOMContentLoaded', function () {
  const hero = document.querySelector('.editor-section'); 
  const stickyBar = document.querySelector('.button-section.mobile-only-sticky-btn');

  if (!hero || !stickyBar) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    },
    {
      root: null,
      threshold: 0
    }
  );

  observer.observe(hero);
});
